import { EnvelopeSimple, Lock, User, Eye, EyeSlash, Gift } from '@phosphor-icons/react';

export function LoginForm({ email, setEmail, password, setPassword, showPassword, setShowPassword }) {
  return (
    <>
      <EmailField email={email} setEmail={setEmail} />
      <PasswordField password={password} setPassword={setPassword} showPassword={showPassword} setShowPassword={setShowPassword} />
    </>
  );
}

export function RegisterForm({ name, setName, email, setEmail, password, setPassword, showPassword, setShowPassword, referralCode, setReferralCode }) {
  return (
    <>
      <div>
        <label className="label-tactical block mb-2">Full Name</label>
        <div className="relative">
          <User className="absolute left-3 top-1/2 -translate-y-1/2 text-[#71717A] w-5 h-5" />
          <input data-testid="register-name-input" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" className="input-tactical pl-11" required />
        </div>
      </div>
      <EmailField email={email} setEmail={setEmail} />
      <PasswordField password={password} setPassword={setPassword} showPassword={showPassword} setShowPassword={setShowPassword} />
      <div>
        <label className="label-tactical block mb-2 flex items-center gap-2">
          Referral code
          <span className="text-[10px] text-[#71717A] normal-case tracking-normal">optional · both get Pro rewards</span>
        </label>
        <div className="relative">
          <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-[#FF9500] w-5 h-5" />
          <input
            data-testid="register-referral-input"
            type="text"
            value={referralCode || ''}
            onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
            placeholder="GRIT-XXXXX"
            className="input-tactical pl-11 uppercase tracking-wider"
            maxLength={20}
          />
        </div>
      </div>
    </>
  );
}

export function ForgotForm({ email, setEmail }) {
  return <EmailField email={email} setEmail={setEmail} />;
}

export function ResetForm({ newPassword, setNewPassword }) {
  return (
    <div>
      <label className="label-tactical block mb-2">New Password</label>
      <div className="relative">
        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-[#71717A] w-5 h-5" />
        <input data-testid="new-password-input" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Min 6 characters" className="input-tactical pl-11" required minLength={6} />
      </div>
    </div>
  );
}

function EmailField({ email, setEmail }) {
  return (
    <div>
      <label className="label-tactical block mb-2">Email</label>
      <div className="relative">
        <EnvelopeSimple className="absolute left-3 top-1/2 -translate-y-1/2 text-[#71717A] w-5 h-5" />
        <input data-testid="auth-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="input-tactical pl-11" required />
      </div>
    </div>
  );
}

function PasswordField({ password, setPassword, showPassword, setShowPassword }) {
  return (
    <div>
      <label className="label-tactical block mb-2">Password</label>
      <div className="relative">
        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-[#71717A] w-5 h-5" />
        <input data-testid="auth-password-input" type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" className="input-tactical pl-11 pr-11" required minLength={6} />
        <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#71717A] hover:text-white transition-colors">
          {showPassword ? <EyeSlash className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
        </button>
      </div>
    </div>
  );
}
